import { render, staticRenderFns } from "./AssociatedQuoteComponent.vue?vue&type=template&id=99a6a058&scoped=true"
import script from "./AssociatedQuoteComponent.vue?vue&type=script&lang=js"
export * from "./AssociatedQuoteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a6a058",
  null
  
)

export default component.exports